import { Box } from "@chakra-ui/react";
import HeaderTable from "./HeaderTable";
import { Empty } from "antd";
import FooterTable from "./FooterTable";
import ItemTable from "./ItemTable";
import { OrcamentoCotacaoItem } from "features/orcamento/typings";

interface TableItensCotadosProps {
  data?: OrcamentoCotacaoItem[];
  isLoading?: boolean;
}

export default function TableItensCotados({
  data,
  isLoading,
}: TableItensCotadosProps) {
  let total = data?.reduce(
    (accumulator, currentValue) => accumulator + currentValue.total!,
    0
  );
  return (
    <Box>
      <HeaderTable />

      {!isLoading && !data?.length ? (
        <Box mt={4}>
          <Empty description="Sem itens." />{" "}
        </Box>
      ) : null}

      {!isLoading && data?.length ? (
        <>
          {data?.map((item) => (
            <ItemTable key={item.id} item={item} />
          ))}
        </>
      ) : null}

      {data?.length ? (
        <FooterTable totalItens={data?.length} total={total} />
      ) : null}
    </Box>
  );
}
